import React, {useState} from 'react';

export default function Tooltip({children}) {
    const [open, setOpen] = useState(false);
    return (
        <span className={`tooltips ${open ? 'show' : ''} ml-2`}>
            <a href={"#"} onClick={() => setOpen(!open)} className="tooltip-toggle">?</a>
            <div className="tooltips_body">
                <a href={"#"} onClick={() => setOpen(false)} className="tooltip-toggle close"/>
                {children}
            </div>
        </span>
    )
}